import React, { Component } from 'react';
import { FormLayout, TextField } from '@envoy/polarwind';
import Select from './components/Select';

class ChoiceColumnAction extends Component {

  onChangeAction = action => {
    const { mapping, mappingIndex } = this.props;
    const changes = { action };
    if (action === 'map') {
      changes.choiceMappings = null;
    }
    this.props.onChangeFieldMapping({ ...mapping, ...changes }, mappingIndex);
  };

  render() {
    const { column, mapping } = this.props;
    return (
      <FormLayout.Group>
        <TextField label="ServiceNow column" value={column.label} disabled />
        <Select
          label="Action"
          options={ChoiceColumnAction.actionOptions}
          value={mapping.action}
          onChange={this.onChangeAction}
          required
        />
      </FormLayout.Group>
    );
  }

  static get actionOptions() {
    return [
      {
        label: 'Create new choice if not found',
        value: 'find_or_create',
      },
      {
        label: 'Leave blank if choice is not found',
        value: 'find',
      },
      {
        label: "Map to Envoy's values",
        value: 'map',
      }
    ];
  }
}

export default ChoiceColumnAction;
